// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quote-wrapper {
  padding: 20px;
}

.quote-title {
  color: white;
  margin-bottom: 20px;
}

.jokes-btn{
   float:right;
  margin-top: 5px;
  /* padding: 8px 14px; */
  border: none;
  background: #2563eb;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
}

/* CARD */
.chat-card {
    background: white;
    padding: 5px 10px;
    border-radius: 14px;
    margin-bottom: 10px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    overflow-y: hidden;
}

/* TITLE */
.chat-title {
  color: #38bdf8;
  margin-bottom: 10px;
}

/* MESSAGES */
.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* BUBBLE */
.chat-bubble {
  background: white;
  /* padding: 10px 14px; */
  border-radius: 10px;
}

/* ROLE */
.chat-role {
  font-weight: bold;
  color: #22c55e;
  margin-right: 5px;
}

/* TEXT */
.chat-text {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/jokes/jokes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;GACG,WAAW;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,SAAS;AACT;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,YAAY;AACd","sourcesContent":[".quote-wrapper {\n  padding: 20px;\n}\n\n.quote-title {\n  color: white;\n  margin-bottom: 20px;\n}\n\n.jokes-btn{\n   float:right;\n  margin-top: 5px;\n  /* padding: 8px 14px; */\n  border: none;\n  background: #2563eb;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n/* CARD */\n.chat-card {\n    background: white;\n    padding: 5px 10px;\n    border-radius: 14px;\n    margin-bottom: 10px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n    overflow-y: hidden;\n}\n\n/* TITLE */\n.chat-title {\n  color: #38bdf8;\n  margin-bottom: 10px;\n}\n\n/* MESSAGES */\n.chat-messages {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* BUBBLE */\n.chat-bubble {\n  background: white;\n  /* padding: 10px 14px; */\n  border-radius: 10px;\n}\n\n/* ROLE */\n.chat-role {\n  font-weight: bold;\n  color: #22c55e;\n  margin-right: 5px;\n}\n\n/* TEXT */\n.chat-text {\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
